import {
    getServerSidePropsWithContentItem,
    V3ContentItemPublicPageLayoutContainer
} from "../../../../../../pagelayouts/content-details/ContentDetailsPublicPageLayoutContainer";

export default function ContentItemSmartShareStandalonePublicPage() {
    return (
        <V3ContentItemPublicPageLayoutContainer
            isStandaloneCollectionView
            isStandaloneContentItemView={false}
            useProfileSmartShareEndpoint={false}
            useArticleSmartShareEndpoint={false}
        />
    );
}

export const getServerSideProps = getServerSidePropsWithContentItem(true, false, true);
